<h1 class="h1">{{ 'companies.titles.MAIN' | translate }}</h1>
<router-outlet></router-outlet>